import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { getInitials } from 'uplisting-frontend/utils/get-initials';

export enum ClientStatus {
  active = 'active',
  archived = 'archived',
}

export enum ClientAttributionType {
  checkIn = 'check_in',
  checkOut = 'check_out',
  prorated = 'prorated',
}

export default class ClientModel extends Model {
  @attr('string') name!: string;
  @attr('string') email!: string;
  @attr('string') status!: ClientStatus;
  @attr('string', { defaultValue: ClientAttributionType.checkOut })
  attributionType!: ClientAttributionType;

  // Leaving those commented out for now, as they are needed in terms of the future UI stuff, but not yet implemented on the BE
  // @attr('string') companyName!: string;
  // @attr('string') avatar!: string;
  // @attr('string') phoneNumber!: string;

  @attr('string') addressStreet!: string;
  @attr('string') addressSuite!: string;
  @attr('string') addressCity!: string;
  @attr('string') addressCountry!: string;
  @attr('string') addressZipCode!: string;
  @attr('string') taxNumber!: string;

  @hasMany('user', { inverse: 'client', async: false })
  users!: ModelRegistry['user'][];

  @hasMany('invitation', { inverse: 'client', async: false })
  invitations!: ModelRegistry['invitation'][];

  @hasMany('permission', { inverse: 'client', async: false })
  permissions!: ModelRegistry['permission'][];

  @hasMany('client-property', { inverse: 'client', async: false })
  clientProperties!: ModelRegistry['client-property'][];

  @hasMany('teammate', { inverse: 'client', async: false })
  teammates!: ModelRegistry['teammate'][];

  @belongsTo('tax', { inverse: 'client', async: false })
  tax?: ModelRegistry['tax'];

  @cached
  get isActive(): boolean {
    return this.status === ClientStatus.active;
  }

  @cached
  get isArchived(): boolean {
    return this.status === ClientStatus.archived;
  }

  @cached
  get initials(): string {
    return getInitials(this.name);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    client: ClientModel;
  }
}
